<script>
import mixins from "../../mixins/index";
import { BaseSelect, BaseIcon } from "@/components";
import { mapGetters } from "vuex";
export default {
  name: "MAccordioSubItemAlgoServer",
  mixins: [mixins],
  components: { BaseSelect, BaseIcon },
  props: {
    item: Object,
    dataItem: Object,
    isResponsive: Boolean,
    gridIsDisable: Boolean,
  },
  computed: {
    ...mapGetters(["getSelectedAlgoServerInfo"]),
    check() {
      return this.dataItem?.algorithm?.find(
        (o) => o.algorithmFeature.id === this.item.id
      );
    },
  },
  methods: {
    changeActive() {
      this.checked = !this.checked;
      this.showSelectbox = !this.showSelectbox;
      return this.checked;
    },
    changeAlgoServer(item) {
      this.changeActive();
      const args = {
        ...item,
        dateSelection: this.startDateSelection,
        isChecked: this.checked,
      };
      this.$emit("changeAlgoServerItems", args);
    },
    changeStartDate(value) {
      this.startDateSelection = value.code;
      const args = {
        ...this.item,
        dateSelection: this.startDateSelection,
      };
      this.$emit("changeAlgoServerItems", args);
    },
    checkStartDateByRow() {
      const getStartDate = this.dataItem.algorithm.find(
        (o) => o.algorithmFeature.id === this.item.id
      );
      if (getStartDate != undefined) {
        this.startDateSelection = Number(getStartDate.dateSelection.key);
        this.showSelectbox = true;
      }
    },
  },
  mounted() {
    if (this.dataItem && this.check) {
      this.changeActive();
      this.checkStartDateByRow();
      const args = {
        ...this.item,
        dateSelection: this.startDateSelection,
        isChecked: this.checked,
      };
      this.$emit("changeAlgoServerItems", args);
    }
  },
  data() {
    return {
      checked: false,
      itemName: this.item?.name,
      itemFundAmount: this.item?.fundAmount,
      itemCommissionAmount: this.item?.commissionAmount,
      itemPriceInfo: this.item?.priceInfo,
      itemPrice: this.item?.price,
      showSelectbox: false,
      startDateSelection: this.dataItem ? this.dataItem.dateSelection : -1,
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
    };
  },
  watch: {
    item: {
      handler(val) {
        //dataItem - Checkout detail response ile dolan bir property yani dataItem koşulu varsa checkout sayfası için bu geliştirme yapılmış demektir.
        if (!this.dataItem && val.isDisable) {
          this.showSelectbox = false;
        }
        if (
          (!this.dataItem &&
            this.startDateSelection == -1 &&
            val.isChecked == "false") ||
          !val.isChecked
        ) {
          this.checked = true;
          this.checked = false;
        }
        if (val.algorithmId == 80 && val.showNextMonth) {
          this.startDate = [
            {
              label: "Ay Başında",
              code: 1,
            },
          ];
          this.startDateSelection = 1;
        } else if (val.algorithmId == 80 && !val?.showNextMonth) {
          //alttaki if bloğunu silmeyin
          // üst dizinde eğer algo seçiili ise algorithmıD 80 olaran ürünün isChecked property'sini false'a çekiyor.
          //ancak bu component id'si 5 olarak güncellendiği için algorithmID 80 olan datasını güncellemiyor.
          // aşağıda bu kontrolü yapıyoruz. eğer id'si 80 olan isChecked false ise önce true'ya çekerek tekrar render etmesi için force ediyoruz.
          // sonra tekrardan inital değeri false olduğu için false'a set edeek sorunu çözüyoruz.
          if (val.isChecked == "false" || !val.isChecked) {
            this.checked = true;
            this.checked = false;
          }
          this.startDate = [
            {
              label: "Seçiniz",
              code: -1,
            },
            {
              label: "Hemen",
              code: 0,
            },
            {
              label: "Ay Başında",
              code: 1,
            },
          ];
        }
        if (
          this.dataItem &&
          val.algorithmId == 80 &&
          !val.isDisable &&
          val.isChecked
        ) {
          const getStartDate = this.dataItem.algorithm.find(
            (o) => o.algorithmFeature.algorithmId === val.algorithmId
          );
          if (getStartDate != undefined) {
            this.startDateSelection = Number(getStartDate.dateSelection.key);
            if (this.item.isChecked) {
              this.checked = this.item.isChecked;
              this.showSelectbox = true;
            }
            if (val?.showNextMonth) {
              this.startDateSelection = 1;
            } else {
              this.startDateSelection = this.dataItem
                ? getStartDate.dateSelection.key
                : -1;
            }
          }
        } else if (
          this.dataItem &&
          val.algorithmId == 80 &&
          val.isDisable &&
          !val.isChecked
        ) {
          this.showSelectbox = false;
          this.startDateSelection = -1;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<template>
  <tr
    v-if="!isResponsive"
    :class="{
      disableRow: gridIsDisable && item.algorithmId != 80,
      active: checked,
    }"
  >
    <td v-if="gridIsDisable && item.algorithmId == 80">
      <div class="tag tooltip">
        <div class="tooltiptext">
          <div class="texts">
            IQ Grid ürünü sadece IQ Algo ürünü ile birlikte alınabilir.
          </div>
          <div class="triangle-down"></div>
        </div>
        <span class="text">
          <base-icon name="green-info" class="icon"></base-icon
        ></span>
      </div>
    </td>
    <td v-else>
      <input
        type="checkbox"
        :id="itemName"
        class="base-form-checkbox"
        :checked="check && 'checked'"
        @change="changeAlgoServer(item)"
      />
    </td>
    <td>
      {{ itemName }}
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="itemFundAmount">
        BES / Komisyon: {{ formatPrice(itemFundAmount) }}&nbsp;TL /
        {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="itemPrice">
        {{ itemPrice }}
        <span v-if="itemPriceInfo == '₺'"> TL </span>
        <span v-if="itemPriceInfo == '$'"> USD </span>
        <span v-if="itemPriceInfo == '€'"> EUR </span>
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td v-if="showSelectbox">
      <label :for="`startDate-${item.id}`">Başlangıç zamanı</label>
      <base-select
        fieldLabel="Başlangıç Zamanı"
        :options="startDate"
        id="startTime"
        @change="changeStartDate"
        :selectedId="startDateSelection"
        placeholder="Seçiniz"
        class="start-date-select"
      />
    </td>
    <td v-else>-</td>
  </tr>
  <div
    v-else
    class="responsive-table-container"
    :class="{
      highlight: checked,
      disableRow: gridIsDisable && item.algorithmId != 80,
      active: checked,
    }"
  >
    <div class="mobile-wrap" v-if="gridIsDisable && item.algorithmId == 80">
      <label class="row caption" :for="'input-' + item.id">
        <div class="tag tooltip">
          <div class="tooltiptext">
            <div class="texts">
              IQ Grid ürünü sadece IQ Algo ürünü ile birlikte alınabilir.
            </div>
            <div class="triangle-down"></div>
          </div>
          <span class="text">
            <base-icon name="green-info" class="icon"></base-icon
          ></span>
        </div>
        {{ itemName }}
      </label>
      <div class="row inline">
        <span>BES / Komisyon</span>
        <div v-if="itemFundAmount && itemCommissionAmount">
          {{ formatPrice(itemFundAmount) }}&nbsp;TL /
          {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span v-if="itemPriceInfo == '₺'">{{ itemPrice }} TL </span>
        <span v-else-if="itemPriceInfo == '$'">{{ itemPrice }} USD </span>
        <span v-else-if="itemPriceInfo == '€'">{{ itemPrice }} EUR </span>
      </div>
      <div class="row">
        <span class="title" v-if="this.$route.query.isRecommended === undefined"
          >Başlangıç Zamanı</span
        >
        <base-select
          fieldLabel="Başlangıç Zamanı"
          :options="startDate"
          v-if="showSelectbox"
          :id="`startDate-${item.id}`"
          @change="changeStartDate"
          :selectedId="startDateSelection"
          placeholder="Seçiniz"
          class="start-date-select"
        />
        <div class="no-data" v-else>-</div>
      </div>
    </div>
    <div class="mobile-wrap" v-else>
      <label class="row caption" :for="'input-' + item.marketId">
        <input
          type="checkbox"
          :id="itemName"
          class="base-form-checkbox"
          :checked="check && 'checked'"
          @change="changeAlgoServer(item)"
        />
        {{ itemName }}
      </label>
      <div class="row inline">
        <span>BES / Komisyon</span>
        <div v-if="itemFundAmount && itemCommissionAmount">
          {{ formatPrice(itemFundAmount) }}&nbsp;TL /
          {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span v-if="itemPriceInfo == '₺'">{{ itemPrice }} TL </span>
        <span v-else-if="itemPriceInfo == '$'">{{ itemPrice }} USD </span>
        <span v-else-if="itemPriceInfo == '€'">{{ itemPrice }} EUR </span>
      </div>
      <div class="row">
        <span class="title" v-if="this.$route.query.isRecommended === undefined"
          >Başlangıç Zamanı</span
        >
        <base-select
          fieldLabel="Başlangıç Zamanı"
          :options="startDate"
          v-if="showSelectbox"
          :id="`startDate-${item.id}`"
          @change="changeStartDate"
          :selectedId="startDateSelection"
          placeholder="Seçiniz"
          class="start-date-select"
        />
        <div class="no-data" v-else>-</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active {
  background-color: #f9f9fa;
  border-radius: 13px;
}
::v-deep .tag {
  margin-right: 0px !important;
  border-radius: var(--radius-third) !important;
  align-items: center !important;
  text-align: center !important;
  max-width: 110px !important;
  display: inline-flex !important;

  @media (max-width: 768px) {
    width: auto !important;
  }
  .tooltiptext {
    visibility: hidden;
    min-width: 180px !important;
    background-color: #f2f7f6 !important;
    color: #6e9e99 !important;
    text-align: left !important;
    padding: 10px 13px !important;
    position: absolute !important;
    z-index: 1 !important;
    bottom: 140% !important;
    left: 0px !important;
    border-radius: var(--radius-first) !important;
    font-size: 13px !important;
    right: auto !important;
    margin: 0 auto !important;
    transform: translateX(0px) !important;
    border: 1px solid #7ea7a3 !important;

    @media (max-width: 768px) {
      left: 0px !important;
      transform: translateX(0px) !important;
      line-height: normal !important;
      min-width: 245px !important;
      top: 100% !important;
      z-index: 1 !important;
      height: max-content !important;
      bottom: auto !important;
    }

    .texts {
      font-size: 12px !important;
      font-weight: normal !important;
    }
    .triangle-down {
      @media (max-width: 768px) {
        border-top: none !important;
        border-bottom: 8px solid #7ea7a3 !important;
        bottom: auto !important;
        top: -8px !important;
        &::after {
          border-bottom: 6px solid #f2f7f6 !important;
          border-top: none !important;
          bottom: auto !important;
          top: 1px !important;
        }
      }
    }
  }

  .text {
    font-size: 12px !important;
    text-overflow: ellipsis !important;
    display: flex !important;
    align-items: center !important;
  }
}
.responsive-table-container {
  width: 100%;
  .data-container {
    @media (max-width: 460px) {
      width: 65%;
    }
  }
  .title-container {
    font-size: 12px;
    @media (max-width: 460px) {
      width: 35%;
    }
  }
}

.bold {
  font-weight: 700;
}
</style>
